export enum TaxonomyFeature {
  GA = 'ga',
  AI = 'ai'
}
